import React, { FC, ReactElement, useState } from 'react'
import { Provider } from 'react-redux'
import OrderNotifications from './OrderNotifications'
import { store } from '../../store'
import DashboardContent from './DashboardContent'
import DashboardNavigation from './Navigation'
import { getQueryParamsState, setQueryParamsState } from '../../utils/queryParams'
import { SchedulerDashboardProps, SchedulerDashboardSearchParams } from './types'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import '../Shared/Ant/App.less'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

export const SchedulerDashboard: FC<SchedulerDashboardProps> = ({
  isTransactionTypeEnabled,
  companyId,
  isActivityFeedDisabled,
  isSweepingEnabled,
  isRootCompany
}): ReactElement => {
  const [searchParams, setSearchParams] = useState<SchedulerDashboardSearchParams>(getQueryParamsState())

  const changeSearchParams = (params: SchedulerDashboardSearchParams) => {
    setQueryParamsState(params)
    setSearchParams(params)
  }

  if (window.location.pathname === '/orders') {
    return (
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <DashboardNavigation
            ordersPage={true}
            companyId={companyId}
            searchParams={searchParams}
            changeSearchParams={changeSearchParams}
          />
          <div className="content" style={isActivityFeedDisabled ? { marginRight: '13px' } : undefined}>
            <DashboardContent
              companyId={companyId}
              transactionTypeFlipper={isTransactionTypeEnabled}
              searchParams={searchParams}
              changeSearchParams={changeSearchParams}
              isSweepingEnabled={isSweepingEnabled}
              isRootCompany={isRootCompany}
            />
          </div>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    )
  }

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <DashboardNavigation
          ordersPage={false}
          companyId={companyId}
          searchParams={searchParams}
          changeSearchParams={changeSearchParams}
        />
        <OrderNotifications
          isRootCompany={isRootCompany}
          searchParams={searchParams}
          changeSearchParams={changeSearchParams}
        />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  )
}
